(function() {
 
        function muteToggle(video){

                if(video.muted){
                    video.muted = false;
                }else{
                    video.muted = true;
                }

        }

        function playVids(vid){

                var video = vid.querySelector('video');

                if(video){

                        video.play();

                        var mutedBtns = vid.querySelectorAll('.mute-btn');

                        mutedBtns.forEach(function(mutedBtn){
                                mutedBtn.addEventListener("click", function(){
                                      
                                        muteToggle(video);
                                });
                         });
                }

        }

        function stopAllVids(){
                var vids = document.querySelectorAll('video');
                vids.forEach(function(vid){
                        vid.pause();
                        vid.currentTime = 0;
                })

        }

        


        if(document.querySelectorAll('.carousel-cell').length > 1) { 

        var elem = document.querySelector('.carousel-main');
        // elem.classList.remove('is-hidden');
        elem.offsetHeight;
        var flkty = new Flickity( elem, {
                // options
                cellAlign: 'center',
                contain: false,
                wrapAround: true,
                prevNextButtons: false,
                pageDots: false,
                // lazyLoad: true
        });

        
        flkty.on('change', function(){
                stopAllVids();
                playVids(flkty.selectedElement);
        });



        
        var elemNav = document.querySelector('.carousel-nav');
        // elem.classList.remove('is-hidden');
        elemNav.offsetHeight;
        var flktyNav = new Flickity( elemNav, {
                // options
                asNavFor:'.carousel-main',
                cellAlign: 'center',
                contain: true,
                prevNextButtons: false,
                pageDots: false
          });
        }


        
        // console.log('checked');
        document.body.addEventListener( 'variant-blend:changed', function(){
                console.log('checked');
        } );
        // window.addEventListener('', function(event){
        //         console.log('triggered');
        //         // flkty.select( index, isWrapped, isInstant )
        // });
 
}());